import axios from 'axios';
import qs from 'qs';
import { push } from 'react-router-redux';

// import { DEFAULT_PAYMENT_METHOD } from '../constants';

export const FETCH_PAYER_INFO = 'shop/FETCH_PAYER_INFO';
export const FETCH_PAYER_INFO_DONE = 'shop/FETCH_PAYER_INFO_DONE';
export const CREATE_ORDER = 'shop/CREATE_ORDER';
export const CREATE_ORDER_DONE = 'shop/CREATE_ORDER_DONE';
export const FETCH_ORDER = 'shop/FETCH_ORDER';
export const FETCH_ORDER_DONE = 'shop/FETCH_ORDER_DONE';

export const FETCH_VIP_PAYMENT_METHOD = 'shop/FETCH_VIP_PAYMENT_METHOD';
export const FETCH_VIP_PAYMENT_METHOD_DONE = 'shop/FETCH_VIP_PAYMENT_METHOD_DONE';


export const INIT = 'shop/INIT';


const initialState = {
    paymentMethods: [],
    defaultPaymentMethod: null,
    paymentMethod: null,
    loading: true,
    loadingPayerInfo: true,
    name: '',
    phone: '',
    gender: '',
    email: '',
    cityCode: '',
    townCode: '',
    address: '',
    order: {},
    createOrderDone: false,
    autoTake: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case INIT:
            return { ...state, loading: false, loadingPayerInfo: false, createOrderDone: false, order: {} };
        case FETCH_PAYER_INFO:
            return { ...state, loading: true, loadingPayerInfo: true }
        case FETCH_PAYER_INFO_DONE:
            return {
                ...state,
                ...action.state,
                loading: false,
                loadingPayerInfo: false
            };
        case FETCH_VIP_PAYMENT_METHOD:
            return { ...state, loading: true }
        case FETCH_VIP_PAYMENT_METHOD_DONE:
            return {
                ...state,
                ...action.state,
                loading: false,
            };            
        case CREATE_ORDER:
            return { ...state, order: {}, createOrderDone: false, loading: true };
        case CREATE_ORDER_DONE:
            return {
                ...state,
                ...action.state,
                createOrderDone: true,
                loading: false
            };
        case FETCH_ORDER:
            return { ...state, order: {}, fetchOrderDone: false, loading: true };
        case FETCH_ORDER_DONE:
            return {
                ...state,
                ...action.state,
                fetchOrderDone: true,
                loading: false
            };


        default:
            return state;
    }
}

export const init = () => {
    return dispatch => {
        dispatch({ type: INIT });
    }
}

export const fetchVipPaymentMethod = () => {
    return dispatch => {
        dispatch({
            type: FETCH_VIP_PAYMENT_METHOD
        });
        return axios.get('/api/fetchVipPaymentMethod').then(response => {
            if (response.data.code === 1) {
                const { paymentMethods, paymentMethod, defaultPaymentMethod } = response.data;
                dispatch({
                    type: FETCH_VIP_PAYMENT_METHOD_DONE,
                    state: {
                        paymentMethods,
                        paymentMethod,
                        defaultPaymentMethod,
                    }
                });
            }
        });
    }
}



export const fetchPayerInfo = () => {
    return dispatch => {
        dispatch({
            type: FETCH_PAYER_INFO
        });
        return axios.get('/api/fetchPayerInfo').then(response => {
            if (response.data.code === 1) {
                const payer = response.data.payer || {};
                dispatch({
                    type: FETCH_PAYER_INFO_DONE,
                    state: {
                        autoTake: payer.autoTake,
                        address: payer.address || '',
                        cityCode: payer.cityCode || '',
                        townCode: payer.townCode || '',
                        email: payer.email || '',
                        gender: payer.gender || 'M',
                        name: payer.name || '',
                        phone: payer.phone || '',
                    }
                });
            }
        });
    }
}

export const createOrder = (data) => {
    return dispatch => {
        dispatch({
            type: CREATE_ORDER
        });
        return axios.post('/api/createOrder', qs.stringify(data)).then(response => {
            if (response.data.code === 1) {
                response.data.order.redirectURL = response.data.redirectURL;
                dispatch({ type: CREATE_ORDER_DONE, state: { order: response.data.order } });
            } else {
                dispatch(push('/error'));
            }
        });
    }
}

export const fetchOrder = (data) => {
    return dispatch => {
        dispatch({
            type: FETCH_ORDER
        });
        return axios.get('/api/fetchOrder?'+qs.stringify(data)).then(response => {
            if (response.data.code === 1) {
                // response.data.order.redirectURL = response.data.redirectURL;
                dispatch({ type: FETCH_ORDER_DONE, state: { order: response.data.order } });
            } else {
                dispatch(push('/error'));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/reducer/shop.js